
import * as _m0 from "protobufjs/minimal";
import { withAuthRetry } from '../utils/authRetry';
import { SyncDownstreamSectionsRequest, SyncDownstreamSectionsResponse } from '../syncdownstreamsections';
import { getServiceUrl } from '../utils/api';

export async function syncDownstreamSections(
    request: SyncDownstreamSectionsRequest,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<SyncDownstreamSectionsResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const url = getServiceUrl('reviewservice', 'syncdownstreamsections');

        const encodedRequest = SyncDownstreamSectionsRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: base64
        });
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): SyncDownstreamSectionsResponse => {
        return SyncDownstreamSectionsResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
